<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Details Sales Report</h2>
            </div>
        </div>

        <a-card class="mb-4">
            <h5 class="mb-3">Filter by</h5>

            <!-- <a-form :form="form"  @submit="exportReport"> -->
                <div class="row">
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-input placeholder="Search by SKU" 
                            v-model="title"
                            v-decorator="['title', { rules: [{ required: false }] }]" 
                            size="large" />
                        </a-form-item>
                    </div>
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-select size="large" 
                                @change="selectDevision"
                                show-search :filter-option="filterOption"
                                v-decorator="['devision', { rules: [{ required: false }] }]"
                                placeholder="Search by devision" style="width: 100%">
                                <a-select-option v-for="devision in devisions" :key="devision.id">
                                    {{ devision.name_en }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-select size="large" 
                                @change="selectHub"
                                :value="selectedHubId"
                                show-search :filter-option="filterOption"
                                v-decorator="['hub', { rules: [{ required: false }] }]"
                                placeholder="Search by hub" 
                                style="width: 100%" >
                                <template v-if="selectedDivisionId">
                                    <a-select-option v-for="hub in hubs" :value="hub.id" :key="hub.id">
                                        {{ hub.name }}
                                    </a-select-option>
                                </template>
                                <template v-else>
                                    <a-select-option :value="0">
                                        <span style="color: red">First Select Devision</span> 
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                    </div>
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-range-picker size="large" :allowClear="false"
                            @change="onChangeDate"
                            :default-value="[moment().startOf('month'), moment().endOf('month')]"
                            v-decorator="['date', { rules: [{ required: false }],
                                initialValue: [moment().startOf('month'), moment().endOf('month')] }]"
                            style="width: 100%" />
                        </a-form-item>
                    </div>
                </div>

                <div>
                    <a-button type="primary" size="large" 
                        style="float: right" 
                        html-type="submit" @click="exportReport">
                        Export Report 
                    </a-button>
                </div>
            <!-- </a-form> -->
        </a-card>

        <a-card class="d-none">
            <div class="mb-3" style="text-align: right">
<!-- @click="exportData" -->
                <a-button type="primary" class="px-5" > Export </a-button>
            </div>

            <table style="width: 100%">
                <tr>
                    <th class="table-head">Delivery Date</th>
                    <th class="table-head">Customer Name</th>
                    <th class="table-head">Customer Address</th>
                    <th class="table-head">Customer Contact Number</th>
                    <th class="table-head">Total Sales (Regular + Brown)</th>
                    <th class="table-head">Customer Feedback</th>
                </tr>
                <tr v-for="n in 10" :key="n">
                    <td class="table-b">21-Sep-2021</td>
                    <td class="table-b">Md. Sha Amran</td>
                    <td class="table-b">185, Nowbaber Bug, Mirpur-1, Dhaka</td>
                    <td class="table-b">01xxxxxxxxxxx1</td>
                    <td class="table-b">20</td>
                    <td class="table-b"></td>
                </tr>
                <tr>
                    <td colspan="4" class="table-b">Total</td>
                    <td class="table-b">16</td>
                    <td class="table-b"></td>
                </tr>
                
            </table>
        </a-card>
    </div>
</template>

<script>
import moment from "moment";
import { HUB_LIST, DIVISION_LIST, SELES_REPORT_EXPORT } from "../../../script/api";
import { getData } from '../../../script/api-service';
import {buildSearchQuery} from "../../../script/helper";

export default {
    data() {
        return {
            search: {},
            earnings: [],
            devisions: [],
            hubs: [],
            form: this.$form.createForm(this, { name: 'searchDivision' }),
            selectedDivisionId: null,
            selectedHubId: undefined,
            dateValue: [moment().startOf('month').format("YYYY-MM-DD"), moment().endOf('month').format("YYYY-MM-DD")],
            title: ""
        };
    },
    methods: {
        moment,
        defaultDateValue() {
            return [moment().startOf('month'), moment()] //.endOf('month')
        },
        async getHubAndDivisionlist() {
            let insatnce = this;
            function gethubList() {
                return getData(HUB_LIST);
            }

            function getDivisionList() {
                return getData(DIVISION_LIST);
            }

            Promise.all([gethubList(), getDivisionList()])
                .then(function (results) {
                    const hubMaster = results[0];
                    const DivisionMaster = results[1];

                    insatnce.devisions = DivisionMaster.data.data;
                    insatnce.hubs = hubMaster.data.data;
                }).catch(err => console.log("err", err));
        },
        exportReport(e) {
            e.preventDefault();
            // this.form.validateFields( async(err, values) => {
            //     if (!err) {
            //         // hub
            //         let { date, title, devision } = values;
                    let from_date = null,
                        to_date = null;

                    if (this.dateValue?.length) {
                        from_date = this.dateValue[0];
                        to_date = this.dateValue[1];
                    }

                    let data = buildSearchQuery({
                        sku: this.title, division_id: this.selectedDivisionId, hub_id: this.selectedHubId, from_date, to_date
                    });

                    let api_link = process.env.VUE_APP_BASEURL;

                    console.log("data", data);
           
                    let url = api_link + SELES_REPORT_EXPORT + `?${data}`;
                    window.open(url, '_blank');

            //     }
            // })
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        async getDivisions() {
            let res = await getData(DIVISION_LIST);

            if (res) {
                this.devisions = res.data.data;
            }
        },
        selectDevision(value) {
            this.getHubs(value);
            this.selectedDivisionId = value;
            this.selectedHubId = undefined;
        },
        selectHub(value) {
            this.selectedHubId = value;
        },
        async getHubs(value) {
            let res = await getData(HUB_LIST+ `?division_id=${value}`);

            if (res) {
                let masterData = res.data.data;
                this.hubs = masterData;
            }
        },
        onChangeDate(value, dateString) {
            console.log('Selected Time: ', value);
            this.dateValue = dateString;
        }
    },
    mounted() {
        // this.getHubAndDivisionlist();
        this.getDivisions()
    },
}
</script>

<style scoped>
    table, th, td {
        border-collapse:collapse;
    }
    .table-head {
        padding: 16px 16px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
        text-align: left;
        background: #fafafa;
        border-bottom: 1px solid #e8e8e8;
        transition: background 0.3s ease;
    }
    .table-b {
            padding: 16px 16px;
            overflow-wrap: break-word;
            border-bottom: 1px solid #e8e8e8;
            transition: background 0.3s;
            border: 1px solid rgb(241, 241, 241);    padding: 16px 16px;
            overflow-wrap: break-word;
            border-bottom: 1px solid #e8e8e8;
            transition: background 0.3s;
            border: 1px solid rgb(241, 241, 241);
    }
</style>